import React from 'react';
import PropTypes from 'prop-types';

const CloseIcon = ({ className }) => {
    return (
        <svg
            width="17"
            height="17"
            viewBox="0 0 17 17"
            fill="none"
            className={`fill-current ${className}`}
            xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M1.46978 15.7735C1.17689 15.4806 1.17689 15.0057 1.46978 14.7128L14.7123 1.47027C15.0052 1.17737 15.4801 1.17737 15.773 1.47026C16.0659 1.76316 16.0659 2.23803 15.773 2.53093L2.53044 15.7735C2.23755 16.0664 1.76268 16.0664 1.46978 15.7735Z" fill="currentColor"/>
            <path fillRule="evenodd" clipRule="evenodd" d="M1.46978 1.47065C1.76268 1.17775 2.23755 1.17775 2.53044 1.47065L15.773 14.7132C16.0659 15.0061 16.0659 15.481 15.773 15.7739C15.4801 16.0668 15.0052 16.0668 14.7124 15.7739L1.46978 2.53131C1.17689 2.23841 1.17689 1.76354 1.46978 1.47065Z" fill="currentColor"/>
        </svg>
    );
};

CloseIcon.propTypes = {
    className: PropTypes.string,
};

CloseIcon.defaultProps = {
    className: '',
};

export default CloseIcon;
